import { Box, styled } from '@common-components';

interface IndentedBoxProps {
  level: number;
}

export const IndentedBox = styled(Box)<IndentedBoxProps>(({ theme, level = 1 }) => ({
  textIndent: theme.spacing(2 * level),
}));
